import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {ICompetencyNode} from '../competency-node.interface';

@Component({
    selector: 'competency-node',
    templateUrl: 'competency-node.component.html',
    styleUrls: ['competency-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompetencyNodeComponent {
  @Input() public node: ICompetencyNode;
  @Output() public onCompetencyClicked = new EventEmitter<ICompetencyNode>();

  public onNodeClicked(node: ICompetencyNode) {
    if (node.isCompetency) {
      this.onCompetencyClicked.emit(node);
    } else {
      node.isExpanded = !node.isExpanded;
    }
  }

  public onChildNodeClicked(node: ICompetencyNode) {
    this.onCompetencyClicked.emit(node);
  }
}
